var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMirana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 26,
    viewBox: "0 0 141 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mirana"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8298 25.3153C30.643 22.6085 31.6111 19.3958 31.6042 16.1068C31.6233 11.8601 30.0063 7.77897 27.1083 4.75925C24.2102 1.73953 20.2677 0.0278942 16.1461 0C14.1027 0.00967401 12.0811 0.433959 10.1968 1.24864C8.31253 2.06333 6.6025 3.25246 5.16424 4.74812C3.72597 6.24378 2.58772 8.01669 1.81444 9.96562C1.04116 11.9146 0.648082 14.0013 0.657514 16.1068C0.650625 19.3958 1.61849 22.6085 3.43173 25.3153C4.84824 23.1875 6.74585 21.4466 8.96091 20.243C11.176 19.0393 13.6419 18.409 16.1461 18.4063C18.6451 18.4141 21.105 19.0469 23.3143 20.2503C25.5236 21.4538 27.4162 23.1919 28.8298 25.3153Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.6323 18.554L41.8209 9.45104V18.554H39.1797V6.76129H43.2745L47.7174 15.1048L52.1604 6.76129H56.2552V18.554H53.6037V9.44049L48.8026 18.5434L46.6323 18.554Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M64.6291 18.554H61.9163V6.76129H64.6291V18.554Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M69.9217 13.0479H78.1114C79.6879 13.0479 80.5989 12.3412 80.5989 11.1176C80.5989 9.89405 79.6879 9.1557 78.1114 9.1557H69.9217V6.76129H78.2445C81.2439 6.76129 83.281 8.25911 83.281 11.0965C83.313 12.036 83.0227 12.957 82.461 13.6977C81.8994 14.4385 81.1023 14.9516 80.2099 15.147L83.5882 18.554H80.5171L77.4459 15.3896H72.7266V18.554H70.0138L69.9217 13.0479Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M94.7057 9.54597L89.413 18.554H86.516L93.1906 6.76129H96.2617L102.936 18.554H99.9983L94.7057 9.54597Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M120.288 18.554H117.893L109.242 10.3476V18.554H106.622V6.76129H109.396L117.657 14.5035V6.76129H120.288V18.554Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M132.317 9.54597L127.024 18.554H124.137L130.812 6.76129H133.883L140.558 18.554H137.63L132.317 9.54597Z",
    fill: "#808080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirana);
export default __webpack_public_path__ + "static/media/mirana.149773388912b514674833754abed465.svg";
export { ForwardRef as ReactComponent };